import { Icon, Link, Tooltip } from '@joor/design-system'
import { useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components/macro'

import { fromGlobalId } from 'utils/transformations/graphql'

import {
  isAccountTypeBrand as isAccountTypeBrandSelector,
  isEditBillingShippingRestricted as isEditBillingShippingRestrictedSelector,
} from 'store/currentUser/selectors'

import { RETAILER_PROFILE, RETAILER_VIEW_OWN_PROFILE } from 'routes/paths'

import { messages } from 'features/Orders/Review/components/Overview/components/AddressesWidget/constants/messages'

export function CreateAddressLink({
  retailerId,
  isRetailerRestricted,
  createAddressId,
}: {
  retailerId: string | undefined
  isRetailerRestricted: boolean
  createAddressId?: string
}) {
  const isAccountTypeBrand = useSelector(isAccountTypeBrandSelector)
  const isAccountTypeRetailer = !isAccountTypeBrand

  const isEditBillingShippingRestricted = useSelector(
    isEditBillingShippingRestrictedSelector,
  )

  const isRetailerEditionRestricted =
    isAccountTypeRetailer && isRetailerRestricted

  const realRetailerId = fromGlobalId(retailerId).id

  if (
    isEditBillingShippingRestricted ||
    isRetailerEditionRestricted ||
    !realRetailerId
  ) {
    return null
  }

  const urlForBrand = generatePath(RETAILER_VIEW_OWN_PROFILE, {
    retailerId: realRetailerId,
    matchType: '',
  })
  const urlForRetailer = generatePath(RETAILER_PROFILE, {
    accountId: realRetailerId,
  })
  const url = isAccountTypeBrand ? urlForBrand : urlForRetailer

  const tooltipContent = messages.getCreateNewTooltip(isAccountTypeBrand)

  return (
    <Wrapper>
      <Link
        href={url}
        target="_blank"
        letterSpacing="tighter"
        fontSize="small"
        fontWeight="medium"
        id={createAddressId}
      >
        {messages.createNew}
      </Link>
      <Tooltip content={tooltipContent} defaultPlacement="bottom">
        <Icon iconName="information" iconSize="small" variant="ACTIVE" />
      </Tooltip>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
